import { Box, Heading } from "@chakra-ui/layout";
import { AspectRatio, Image } from "@chakra-ui/react";
import { Number } from "components";

export const HowItWorksStep = ({ title, number, children, color }: any) => {
  return (
    <Box pl={{base: 12, lg: 0}} position="relative">
      <Box mb={3} left={0} top={0} position={{base: "absolute", lg: "relative" }} mr={{base: 4, lg: 0}}>
        <Number number={number} color={color} />
      </Box>
      <Heading fontSize="xl" mb={2}>
        {title}
      </Heading>
      <Box fontSize="md" color="gray.600" fontWeight={400} maxW="sm">
        {children}
      </Box>
    </Box>
  );
};
